// extracted by mini-css-extract-plugin
module.exports = {"base":"Divider_base__33oB5","weight-regular":"Divider_weight-regular__hkDSB","weight-strong":"Divider_weight-strong__ROK7c","weight-light":"Divider_weight-light__5HlHt"};